import { Component, OnInit } from '@angular/core';
import {
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
} from 'src/app/shared/enums';
import * as day from 'dayjs';
import { BadeLoftService } from '../bade-loft.service';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-integration-status',
  templateUrl: './integration-status.component.html',
  styleUrls: ['./integration-status.component.css'],
})
export class IntegrationStatusComponent implements OnInit {
  page: number = 1;
  integrationMaxPageSize: number = 1;
  isIntegrationsLoaded: boolean = false;
  isApiRunning: any;
  sortBy: any = SortBy.Dsc;
  sortField: any = 'CreatedOn';
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  pageSize: number = 100;
  lst_Logs: any[] = [];
  filterDate: any = [];
  ranges: any = {
    Today: [day(), day()],
    Yesterday: [day().subtract(1, 'days'), day().subtract(1, 'days')],
    Tomorrow: [day().add(1, 'days'), day().add(1, 'days')],
    'Last 7 Days': [day().subtract(6, 'days'), day()],
    'Last 30 Days': [day().subtract(29, 'days'), day()],
    'This Month': [day().startOf('month'), day().endOf('month')],
    'Last Month': [
      day().subtract(1, 'month').startOf('month'),
      day().subtract(1, 'month').endOf('month'),
    ],
  };
  selected: { start: Date; end: Date };
  protectionRoute: any = 'all';
  constructor(private _blS: BadeLoftService, public _cS: CommonService) {}

  ngOnInit(): void {}
  onScrollDown() {
    if (this.page != this.integrationMaxPageSize) {
      this.page += 1;
      this.getIntegrationLogsList();
    }
  }
  getIntegrationLogsList() {
    try {
      this.isIntegrationsLoaded = true;
      this.isApiRunning = this._blS
        .GetIntegrationStatus(
          this.searchText.trim(),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          this.filterDate[0],
          this.filterDate[1],
          this.protectionRoute,
          false
        )
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.Success) {
            this.isIntegrationsLoaded = false;
            var data = response.result.records;
            this.integrationMaxPageSize = response.result.totalPage;
            if (data && data.length > 0) {
              data.forEach((x: any) => {
                this.lst_Logs.push(x);
              });
            }
          } else {
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        });
    } catch (error) {}
  }
  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Logs = [];
      if (this.isApiRunning) this.isApiRunning.unsubscribe();
      this.getIntegrationLogsList();
    }
  }
  // protectionRouteValueChanges(routeValue: any) {
  //   this.protectionRoute = routeValue;
  //   this.page = 1;
  //   this.lst_Logs = [];
  //   if (this.isApiRunning) this.isApiRunning.unsubscribe();
  //   this.getIntegrationLogsList();
  // }
  onDateChange(result: any) {
    this.filterDate[0] = result?.startDate?.utc().format();
    this.filterDate[1] = result?.endDate?.utc().format();
    this.lst_Logs = [];
    this.page = 1;
    if (this.isApiRunning) this.isApiRunning.unsubscribe();
    this.getIntegrationLogsList();

    // this.getStatusList();
  }
}
